export const TERMS_CONSTANTS = {
   REVIEW_DOCUMENT : "Please review and sign",
   PRIVATE_MESSAGE : "Private message",
   SIGNATURE_DISCLOSURE : "Please read the Electronic Record and Signature Disclosure",
   CONCENT : "I agree to use electronic records and signatures."
}